import { useState } from "react";
import cn from "classnames";
import { Avatar } from "shared/types/avatar";

import { getAvatarThumbnailSrc } from "shared/components/Avatar";
import { DeactivateModal } from "shared/components/Modals/DeactivateModal";
import { WizardUser } from "shared/components/WizardNew/types";

import { GENDER_FEMALE } from "shared/constants";
import { isDesktop } from "shared/constants/envVariables";
import { LOCAL_STORAGE_KEYS } from "shared/constants/storageKeys";

import { useLocalStorage } from "shared/hooks/useLocalStorage";
import { useOutsideClick } from "shared/hooks/useOutsideClick";

import WizardUserMenuDropDown from "./WizardUserMenuDropDown";

import styles from "@platformAssets/components/Wizard.module.scss";

import { ReactComponent as UserIcon } from "assets/shared/img/icons/user.svg";

type WizardUserMenuProps = {
  userData: WizardUser;
};

export const WizardUserMenu = ({
  userData,
}: WizardUserMenuProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [userAvatar] = useLocalStorage<Avatar | null>(
    LOCAL_STORAGE_KEYS.USER_AVATAR,
    null
  );

  const currentUserAvatar = userData.avatar?.uid ? userData.avatar : userAvatar;

  const menuRef = useOutsideClick(() => {
    setIsOpen(false);
  });

  return (
    <>
      <div ref={menuRef} className={styles.wizardUserMenu}>
        <button
          type="button"
          className={cn(styles.userTrigger, {
            [styles.active]: isOpen,
          })}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {currentUserAvatar?.src ? (
            <div
              className={styles.avatar}
              style={{
                backgroundSize: "cover",
                backgroundImage: `url("${getAvatarThumbnailSrc(
                  currentUserAvatar,
                  GENDER_FEMALE
                )}")`,
              }}
            />
          ) : (
            <UserIcon />
          )}

          {isDesktop && (
            <span className={styles.userName}>{userData.first_name}</span>
          )}
        </button>

        {isOpen && (
          <WizardUserMenuDropDown
            onClose={() => setIsOpen(false)}
            onDeleteAccount={() => {
              setIsOpen(false);
              setIsDeleteModalOpen(true);
            }}
          />
        )}
      </div>

      {isDeleteModalOpen && (
        <DeactivateModal
          handleCloseClick={() => setIsDeleteModalOpen(false)}
          show={isDeleteModalOpen}
          isDeleted={isDeleted}
          onDeletedSuccess={() => setIsDeleted(true)}
          username={userData.first_name}
        />
      )}
    </>
  );
};
